<template>
    <v-card>
        <v-card-title
            class="justify-center mt-1"
            style="
                font-size: 1.9em;
                font-weight: 400;
            "
        >
            Programa de Assinatura
        </v-card-title>
        <v-alert
            v-if="objeto"
            :value="true"
            type="info"
            class="pa-2 ma-0"
            outline
            style="width: 100%; font-size: 1.1em;"
        >
            <b>{{ objeto.nome ? `A Rede ${objeto.nome.replace('Rede', '')}` : `O posto ${objeto.nome_fantasia.replace('Posto', '')}` }}</b>
            deseja utilizar o Programa Assinatura da Apetrus.
        </v-alert>
        <v-card-text
            v-if="objeto"
            style="font-size: 1.1em;"
            class="pl-4 pr-4 pt-0 ma-0"
        >
            <v-flex v-if="objeto.nome" xs12 class="mb-2 mt-3">
                <h3 class="text-xs-center">Dados da Rede</h3>
                <v-layout justify-space-between wrap class="mt-4">
                    <v-flex xs5>
                        <b>Nome do Matriz:</b> {{objeto.matriz.nome_fantasia}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>CNPJ do Matriz:</b> {{formatarCnpj(objeto.matriz.cnpj)}}
                    </v-flex>
                    <v-flex xs12>
                        <b>Razão social do Matriz:</b> {{objeto.matriz.razao_social}}
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-else xs12 class="mb-2 mt-3">
                <h3 class="text-xs-center">Dados do Posto</h3>
                <v-layout justify-space-between wrap class="mt-4">
                    <v-flex xs5>
                        <b>Nome fantasia:</b> {{posto.nome_fantasia}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>CNPJ do Matriz:</b> {{formatarCnpj(posto.cnpj)}}
                    </v-flex>
                    <v-flex xs12>
                        <b>Razão social:</b> {{posto.razao_social}}
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-if="representante" xs12 class="mb-2 mt-4">
                <h3 class="text-xs-center">Dados do Representante</h3>
                <v-layout justify-space-between wrap class="mt-4">
                    <v-flex xs6>
                        <b>Nome completo:</b> {{representante.nome_completo}}
                    </v-flex>
                    <v-flex xs5>
                        <b>CPF:</b> {{formatarCpf(representante.cpf)}}
                    </v-flex>
                    <v-flex xs6 class="mt-2">
                        <b>E-mail:</b> {{representante.email}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>Telefone:</b> {{formatarTelefone(representante.telefone)}}
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 class="mb-2 mt-4" v-if="endereco">
                <h3 class="text-xs-center">Dados do Endereço</h3>
                <v-layout justify-space-between wrap class="mt-4">
                    <v-flex xs5>
                        <b>Logradouro:</b> {{endereco.logradouro}}
                    </v-flex>
                    <v-flex xs5>
                        <b>Número:</b> {{endereco.numero}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>Bairro:</b> {{endereco.bairro}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>Cidade:</b> {{endereco.cidade}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>Estado:</b> {{endereco.estado}}
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                        <b>CEP:</b> {{formatarCep(endereco.cep)}}
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn
                color="error"
                round
                class="mb-3"
                @click="responderSolicitacao(false)"
                :loading="loading"
            >
                Rejeitar
            </v-btn>
            <v-btn
                color="success"
                round
                class="mb-3"
                @click="responderSolicitacao(true)"
                :loading="loading"
            >
                Aceitar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['objeto'],
    data: () => ({
        representante: {},
        posto: {},
        endereco: {}
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        objeto (val) {
            if (val !== null && val !== undefined) {
                if (val.nome) {
                    this.representante = val.representante
                    this.endereco = val.matriz.endereco
                } else {
                    this.pegarDadosPosto(this.objeto.cnpj)
                }
            } else {
                this.representante = {}
                this.endereco = {}
                this.posto = {}
                this.$emit('fechar')
            }
        }
    },
    beforeMount () {
        if (this.objeto) {
            if (this.objeto.nome) {
                this.representante = this.objeto.representante
                this.endereco = this.objeto.matriz.endereco
            } else {
                this.pegarDadosPosto(this.objeto.cnpj)
            }
        } else {
            this.representante = {}
            this.endereco = {}
            this.posto = {}
            this.$emit('fechar')
        }
    },
    methods: {
        pegarDadosPosto (cnpj) {
            this.$store.dispatch('detalhesPosto', cnpj).then(json => {
                this.representante = json.representante
                this.posto = json
                this.endereco = json.endereco
            })
        },
        formatarTelefone (telefone) {
            if (!telefone) return 'Indefinido'
            if (telefone.length < 8) return 'Indefinido'
            if (telefone.length === 8) return `${telefone.slice(0, 4)}-${telefone.slice(4, 8)}`
            if (telefone.length === 9) {
                if (telefone.search('-') === -1) return `${telefone[0]}${telefone.slice(1, 4)}-${telefone.slice(5, 9)}`
                return telefone
            }
            if (telefone.length === 10) return `+(${telefone.slice(0, 2)}) ${telefone.slice(2, 6)}-${telefone.slice(6, 10)}`

            if (telefone.length === 11) return `(${telefone.slice(0, 2)}) ${telefone[2]} ${telefone.slice(3, 7)}-${telefone.slice(7, 11)}`

            if (telefone.length === 14) return `${telefone.slice(0, 3)} (${telefone.slice(3, 5)}) ${telefone[5]} ${telefone.slice(6, 10)}-${telefone.slice(10, 14)}`

            return telefone
        },
        formatarCep (cep) {
            if (!cep) return 'Indefinido'
            if (cep.length < 8) return 'Indefinido'
            if (cep.length === 8) return `${cep.slice(0, 5)}-${cep.slice(5, 8)}`
            return cep
        },
        formatarCpf (cpf) {
            if (!cpf) return 'Indefinido'
            if (cpf.length < 11) return 'Indefinido'
            if (cpf.length === 11) return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}.${cpf.slice(9, 11)}`
            return cpf
        },
        formatarCnpj (cnpj) {
            if (!cnpj) return 'Indefinido'
            if (cnpj.length < 14) return 'Indefinido'
            if (cnpj.length === 14) return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`
            return cnpj
        },
        responderSolicitacao (resposta) {
            let funcaoChamada = 'atualizarTudoPosto'
            const data = { tem_programa_assinatura: resposta }
            if (this.objeto.nome_fantasia) {
                data.cnpj = this.objeto.cnpj
                funcaoChamada = 'atualizarTudoPosto'
            } else {
                data.id_rede = this.objeto.id_rede
                funcaoChamada = 'atualizarTudoRede'
            }
            this.$store.dispatch(funcaoChamada, data).then(() => {
                this.$emit('success', `Solicitação para entrar no programa de assinatura ${resposta ? 'aceita' : 'rejeitada'} com sucesso.`)
                this.$emit('carregar')
                this.$emit('fechar')
            }).catch(() => {
                this.$emit('error', 'Não foi possível responder solicitação.')
            })
        }
    }
}
</script>
